

































































































































import { Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { mixins } from "vue-class-component";
import RequestPromises from "@/mixins/requestPromises";
// types
import { ITicket } from "@/models/tickets";
import Context from "@/mixins/context";
import { ApiOperators } from "@/data/table";
import { TicketStatusCodes } from "@/data/enums/tickets";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "ticket-flag-tooltip": () =>
      import("@/components/app/global/tickets/ticketFlagTooltip.vue")
  }
})
export default class TicketsLatestList extends mixins(
  RequestPromises,
  Context
) {
  @Prop({ required: false, default: undefined })
  public clientId!: IClient["id"];

  @Prop({ required: false, default: () => [] })
  public statuses!: TicketStatusCodes[];

  @Prop({ default: 6 })
  public limit!: number;

  public tickets: ITicket[] = [];
  public hasRequestError = false;
  public isLoading = false;

  // Lifecycle Hooks
  public created() {
    this.loadData();
  }

  // Computed
  public get hasPermissions() {
    return this.$userCan("list_tickets");
  }

  // Methods
  public async loadData() {
    if (this.hasPermissions) {
      this.isLoading = true;
      try {
        await Promise.all([
          this.getData(),
          // Add small delay for smoother transition
          new Promise(resolve => setTimeout(resolve, 250))
        ]);
      } finally {
        this.isLoading = false;
      }
    }
  }

  public async getData() {
    this.hasRequestError = false;
    try {
      this.tickets = await this.$store.dispatch(
        `data/${DataModules.TICKETS}/list`,
        {
          vm: this,
          storeData: false,
          params: {
            limit: this.limit,
            order: "-updated_at",
            with: [
              "status",
              "client",
              "client.image",
              "department",
              "department.brand_ticket_departments"
            ].join(),
            ...this.getFilterForStatuses(),
            ...this.getFilterForClient()
          }
        }
      );
    } catch (error) {
      this.hasRequestError = true;
      this.$store.dispatch("api/handleError", error);
    }
  }

  public getFilterForClient() {
    return this.clientId ? { "filter[client_id]": this.clientId } : {};
  }

  public getFilterForStatuses() {
    return this.statuses.length
      ? { [`filter[status.code|${ApiOperators.EQUAL}]`]: this.statuses.join() }
      : {};
  }

  public getDepartmentName(ticket: ITicket) {
    return this.$store.getters[
      `data/${DataModules.SUPPORT_DEPARTMENTS}/getDepartmentName`
    ](ticket.department, ticket.brand_id);
  }
}
